import {
  articleDetailApi, // 获取文章详细信息
  articleListApi,//查询文章列表
  accessoryListApi,//文章附件列表
  accessoryDetailApi,//获取文章附件详细信息
  personnelApi,
  bannerApi,
  getBlogrollApi
} from './api.js';

// 查询文章列表
export function getArticleListMsg (params, callback) {
  let articleListApiData = articleListApi(params)
  articleListApiData.then((res) => {
    if (res.code === 200) {
      if (res) {
        callback(res)
      }
    }
  }).catch(err => {
    console.log(err);
  })
}

export function downloadByaTag (val, downloadName, istarget = true, isrevoke = false) {
  let elink = document.createElement('a');
  elink.style.display = 'none';
  if (istarget) {
    elink.setAttribute('target', '_blank');
  }
  elink.setAttribute('download', downloadName);
  elink.setAttribute('href', val);
  document.body.appendChild(elink);
  elink.click();
  if (isrevoke) {
    URL.revokeObjectURL(elink.href); // 释放URL 对象
  }
  document.body.removeChild(elink);
}
export function getBanner (callback) {
  let bannerApiData = bannerApi();
  bannerApiData.then((res) => {
    if (res.code === 200) {
      if (res) {
        callback(res.rows)
      }
    }
  }).catch(err => {
    console.log(err);
  })
}
export function getHomeBanner (callback) {
  let bannerApiData = bannerApi({ bannerType: 0 });
  bannerApiData.then((res) => {
    if (res.code === 200) {
      if (res) {
        callback(res.rows)
      }
    }
  }).catch(err => {
    console.log(err);
  })
}
// 友情链接
export function getBlogroll (callback) {
  let blogrollData = getBlogrollApi();
  blogrollData.then((res) => {
    if (res.code === 200) {
      if (res) {
        callback(res.rows)
      }
    }
  }).catch(err => {
    console.log(err);
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/commonFun.js